import { combineReducers } from "redux";
import additionalDevicesReducer from "./additionalDevices/reducers";
import singleProductReducer from "./singleProduct/reducers";

const productsReducer = combineReducers({
  additionalDevices: additionalDevicesReducer,
  singleProduct: singleProductReducer,
});


export default productsReducer;
